import React, { FC } from 'react';
import General from '../../../components/merchants/MerchantPage/MerchantGeneralConfiguration';
import { SFTPSection } from '../../../components/merchants/SFTPSection';
import MerchantConfiguration from '../../../components/merchants/MerchantPage/MerchantConfiguration';
import { IAuthState } from '../../../redux/AuthRedux';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from '../../../../setup';
import { checkRoles, CLAIMS } from '../../../utils/roles-helper';

export const MerchantConfigurationPage: FC = () => {
	const authUser: IAuthState = useSelector<RootState>(({ auth }) => auth, shallowEqual);

	return (
		<>
			<General/>
			{checkRoles(authUser, CLAIMS.SUPER_ADMIN) && (
				<>
					<MerchantConfiguration/>
					<SFTPSection/>
				</>
			)}
		</>
	);
};
